var map = {
	"./hidro01.png": "18f0",
	"./hidro02.png": "516f",
	"./ley-incencios01.png": "1b13",
	"./ley-incendios02.jpg": "6030",
	"./modelo-cs1.png": "fef5",
	"./modelo-cs2.png": "6ebe",
	"./modelo-eg1.png": "a982",
	"./modelo-eg2.png": "a11b",
	"./modelo-en1.png": "2db8",
	"./modelo-en2.png": "617a",
	"./modelo-pp1.png": "adba",
	"./modelo-pp2.png": "0854",
	"./modelo-pr1.png": "d549",
	"./modelo-pr2.png": "b84a",
	"./patrim01.png": "4ef7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d538";